module.exports = __webpack_public_path__ + "img/heartFavActive.53948158.svg";